import {
  AdminCertificatesSettingsTextFieldProps,
  getAdminCertificatesSettingsColumnLabel,
} from "../../../../models/admin-certificates-settings.models";

const AdminCertificatesSettingsTextField = ({
  field,
  value,
  saving,
  type = "text",
  onChange,
}: AdminCertificatesSettingsTextFieldProps) => (
  <label className="grid min-w-0 gap-1 text-xs font-semibold uppercase">
    <span className="truncate">{getAdminCertificatesSettingsColumnLabel(field)}</span>
    <input
      value={value}
      type={type}
      min={type === "number" ? 0 : undefined}
      step={type === "number" ? 1 : undefined}
      disabled={saving}
      data-test={`admin-certificates-settings-modal-field-${field}`}
      className="h-9 w-full min-w-0 border border-gray-300 bg-transparent px-3 text-sm font-normal normal-case outline-none focus:border-green disabled:opacity-50 dark:border-gray-700"
      onChange={(event) => onChange(field, event.target.value)}
    />
  </label>
);

export default AdminCertificatesSettingsTextField;
